import { PureComponent } from 'react'
import RavenJS from 'raven-js'
import Cookie from './Cookie'

const TRACKING_COOKIE_NAME = 'tracking-uid'

export default class RavenWrapper extends PureComponent {
  componentWillMount () {
    const {
      config,
      version,
      environment
    } = this.props

    RavenJS.config(
      config.dsn,
      Object.assign({}, config, {environment, release: version})
    ).install()

    if (RavenJS._isRavenInstalled) {
      window.addEventListener('resize', () => this.setViewportTag())
      this.setViewportTag()
      this.setUserId()
    }
  }

  componentWillUnmount () {
    if (RavenJS._isRavenInstalled) {
      RavenJS.uninstall()
    }
  }

  setUserId () {
    const cookie = new Cookie()
    if (cookie.isSet(TRACKING_COOKIE_NAME)) {
      RavenJS.setUserContext({
        id: cookie.cookieJar[TRACKING_COOKIE_NAME]
      })
    }
  }

  setViewportTag () {
    RavenJS.setExtraContext({
      viewport: `${window.innerWidth}x${window.innerHeight}`
    })
  }

  render () {
    return this.props.children
  }
}
